const ROOT_MARGIN = "0px 0px -12% 0px";
const THRESHOLD = 0.15;
const RESET_SCROLL_Y = 64;

const scrollRevealRuntime = {
  resetBound: false,
  resetRaf: 0,
};

function prepareItem(item, index, reducedMotion) {
  const customIndex = item.getAttribute("data-scroll-reveal-index");
  const revealIndex = customIndex !== null && customIndex !== "" ? customIndex : String(index);
  item.style.setProperty("--scroll-reveal-index", revealIndex);

  if (reducedMotion) {
    item.classList.add("is-scroll-revealed");
    return false;
  }

  if (!item.classList.contains("scroll-reveal__item")) {
    item.classList.add("scroll-reveal__item");
  }

  return true;
}

export function resetScrollReveal(root = document) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll(".scroll-reveal__item").forEach((item) => {
    item.classList.remove("is-scroll-revealed");
  });
  initScrollReveal(scope);
}

export function bindScrollRevealReset() {
  if (scrollRevealRuntime.resetBound) {
    return;
  }
  scrollRevealRuntime.resetBound = true;

  if (isSinglePostPage()) {
    return;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (scrollRevealRuntime.resetRaf) {
        return;
      }
      scrollRevealRuntime.resetRaf = window.requestAnimationFrame(() => {
        scrollRevealRuntime.resetRaf = 0;
        if (window.scrollY > RESET_SCROLL_Y) {
          return;
        }
        resetScrollReveal(document);
      });
    },
    { passive: true },
  );
}

function isSinglePostPage() {
  const body = document.body;
  return !!(body && body.classList.contains("single-post"));
}

function revealScrollItemsImmediately(scope) {
  scope.querySelectorAll("[data-scroll-reveal]").forEach((container) => {
    const itemSelector =
      container.getAttribute("data-scroll-reveal-items") || "[data-scroll-reveal-item]";
    container.querySelectorAll(itemSelector).forEach((item) => {
      item.classList.add("scroll-reveal__item", "is-scroll-revealed");
    });
  });
}

export default function initScrollReveal(root = document) {
  const scope = root && root.querySelectorAll ? root : document;

  if (isSinglePostPage()) {
    revealScrollItemsImmediately(scope);
    return;
  }

  const containers = scope.querySelectorAll("[data-scroll-reveal]");

  if (!containers.length) {
    return;
  }

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  containers.forEach((container) => {
    const itemSelector =
      container.getAttribute("data-scroll-reveal-items") || "[data-scroll-reveal-item]";
    const items = container.querySelectorAll(itemSelector);

    if (!items.length) {
      return;
    }

    if (container.__scrollRevealObserver) {
      container.__scrollRevealObserver.disconnect();
      container.__scrollRevealObserver = null;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }
          entry.target.classList.add("is-scroll-revealed");
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: ROOT_MARGIN,
        threshold: THRESHOLD,
      },
    );

    items.forEach((item, index) => {
      if (!prepareItem(item, index, reducedMotion)) {
        return;
      }
      if (item.classList.contains("is-scroll-revealed")) {
        return;
      }
      observer.observe(item);
    });

    if (!reducedMotion) {
      container.__scrollRevealObserver = observer;
    }
  });
}
